<template>
  <div class="real-name">
    <div class="content">
      <h6>开通平台电子签章实名认证</h6>
      <p>实名认证将验证您的企业信息，整个认证服务流程将在e签宝专业认证平台完成。</p>
  

      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="80px"
        label-position="top"
      >
        <el-form-item :prop=" (compOptions && compOptions.length === 1) || (accessData && accessData.authCompName) ? '' : 'orgName'">
          <template v-slot:label>
            <span>企业名称</span>
          </template>
          <div v-if="!accessData.authCompName && !accessData.legalName">
            <el-input v-model="form.orgName" placeholder="" style="width: 400px"></el-input>
          </div>
          <div v-else>
            <div
              class="read-only"
              v-if="(compOptions && compOptions.length === 1) ||  (accessData && accessData.authCompName)"
            >
              <span v-if="accessData && accessData.authCompName">{{ accessData.authCompName }}</span>
              <span v-else>{{ compOptions[0] }}</span>
            </div>
            <el-select v-else v-model="form.orgName" style="width: 400px">
              <el-option
                v-for="(item, index) in compOptions"
                :key="index"
                :value="item"
                :label="item"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item prop="phone">
          <template v-slot:label>
            <span>法定代表人/负责人手机号</span>
          </template>
          <el-input
            style="width: 400px"
            placeholder="请输入手机号"
            v-model="form.phone"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="btn">
        <el-button
          type="primary"
          @click="startCertification"
          :loading="loading"
        >开始企业实名认证</el-button>
      </div>

      <div
        class="text-btn"
        v-if="accessData && accessData.accessPermission !== 5 && !$route.query.isSkip"
      >
        <el-button type="text" @click="skip">跳过企业实名认证</el-button>
      </div>
    </div>

    <!-- 是否完成实名认证回调弹框 -->
    <el-dialog
      custom-class="real-name-dialog"
      width="600px"
      :visible="visible"
      @close="close"
    >
      <div class="content">
        <h6>企业实名认证结果</h6>
        <p>请在新打开的页面上进行企业实名认证，认证完成后再关闭此窗口</p>
        <el-button type="primary" @click="completeCertification">已完成企业实名认证</el-button>
        <div>企业实名认证遇到问题可联系您的客户经理</div>
        <div>或 拨打 400-660-5995</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  setEsignOrgAuth,
  applySearchPermission,
  getAuthenticationStatus,
} from '@/utils/api/permission-verification.js'
import { mapState, mapActions } from 'vuex'
import { presentUrl } from '@/utils/config.js'
export default {
  computed: {
    ...mapState('permissionVerification', ['accessData']),
  },
  watch: {
    accessData: {
      handler(newVal, oldVal) {
        if (!newVal) return
        // 初始化企业名称选项
        if (this.accessData.authMobile)
          this.form.phone = this.accessData.authMobile
        let regex = /[\-\\/_\\]/
        this.compOptions = newVal?.legalName?.split(regex) || []
        this.compOptions = this.compOptions.filter((ele, index) => {
          return ele.trim()
        })
        this.compOptions = this.compOptions.map((ele) => ele.trim())
        // 查看是否是已认证且未激活，如果是，直接跳到激活页
        if (!newVal) return
        if (newVal.accessPermission === 4 && !oldVal) {
          this.$router.push({
            path: 'launch-product',
            query: {
              to: this.$route.query.to,
              certification: 1,
            },
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    const phoneRules = (rule, value, callback) => {
      // 是不是为空
      if (!value) {
        return callback(new Error('请填写法定代表人/负责人手机号'))
      }
      // 首先判断是否为11位
      if (value.length !== 11) {
        return callback(new Error('请填写11位数字组成的有效手机号'))
      }
      // 判断是否是全是数字组成的
      if (!/^[0-9]+$/.test(value)) {
        return callback(new Error('请填写11位数字组成的有效手机号'))
      }
      // 判断第一位数字是不是1
      if (value[0] != '1') {
        return callback(new Error('请填写11位数字组成的有效手机号'))
      }
      callback()
    }
    return {
      form: {
        orgName: '',
        phone: '',
      },
      rules: {
        orgName: [
          {
            required: true,
            message: '请选择企业名称',
            trigger: ['blur', 'change'],
          },
        ],
        phone: [{ validator: phoneRules, trigger: 'blur' }],
      },
      visible: false,
      loading: false,
      compOptions: [],
    }
  },
  methods: {
    ...mapActions('permissionVerification', ['requestAccessData']),

    // 开始实名认证
    startCertification() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const newPage = window.open()

          this.loading = true
          // 记录行为
          try {
            applySearchPermission({
              compName: this.form.orgName,
              mobile: this.form.phone,
            })
          } catch (err) {
            console.error(
              '❌ ~ file: real-name.vue:191 ~ this.$refs.form.validate ~ err:',
              err
            )
          }

          try {
            let orgName = ''
            if (this.accessData?.authCompName) {
              orgName = this.accessData.authCompName
            } else {
              orgName =
                this.compOptions?.length === 1
                  ? this.compOptions[0]
                  : this.form.orgName
            }

            let redirectUrl 
            if(!this.$route.query.isSkip){  //嗨搜重定向跳转
              redirectUrl =
                this.accessData?.accessPermission !== 5
                  ? presentUrl +
                    this.$router.resolve({
                      path: 'launch-product',
                      query: {
                        to: this.$route.query.to,
                      },
                    }).href
                  : presentUrl +
                    this.$router.resolve({
                      name: 'const-center-real-success',
                    }).href
            }else{   //甄云重定向跳转
              redirectUrl = presentUrl +
                    this.$router.resolve({
                      name: 'agreement-repository',
                    }).href
            }
            const res = await setEsignOrgAuth({
              orgName,
              phone: this.form.phone,
              orgId: this.accessData.orgId,
              roleId: this.accessData.roleId,
              userId: this.accessData.userId,
              redirectUrl,
            })
            if (res.rspResult.bizCode === 200) {
              if (res.data.result) {
                // 已认证
                newPage.close()
                await this.requestAccessData()
                const accessPermission = this.accessData?.accessPermission
                // console.log('accessPermission==',accessPermission)
                if(this.$route.query.isSkip){  //甄云实名认证
                  this.$router.push({
                    name: 'const-center-real-success',
                    query:{
                      from: 'agreement-repository'
                    }
                  })
                }else{   //嗨搜实名认证
                  if (accessPermission === 1) {
                    this.$router.push({
                      name: 'const-center-real-success',
                    })
                  } else {
                    this.$router.push({
                      path: 'launch-product',
                      query: {
                        to: this.$route.query.to,
                      },
                    })
                  }
                }
              } else {
                // 未认证
                newPage.location.href = res.data.authUrl
                this.visible = true
              }
            } else {
              this.$message.error({
                duration: 5000,
                message: res.rspResult.message,
              })
              newPage.close()
            }
            this.loading = false
          } catch (err) {
            console.error(
              '❌ ~ file: real-name.vue:244 ~ this.$refs.form.validate ~ err:',
              err
            )
            this.loading = false
            newPage.close()
          }
        }
      })
    },

    // 关闭弹框
    async close() {
      await this.requestAccessData()
      this.visible = false
    },

    // 点击完成认证
    async completeCertification() {
      try {
        const res = await getAuthenticationStatus({
          orgId: this.accessData.orgId,
        })
        if (res.rspResult.bizCode === 200) {
          if (res.data.result) {
            // 已认证
            const accessPermission = this.accessData?.accessPermission
            await this.requestAccessData()
            if(this.$route.query.isSkip){   //甄云实名
                this.$router.push({
                  name: 'const-center-real-success',
                  query:{
                    from: 'agreement-repository'
                  }
                })
            }else{      //嗨搜实名
              if (accessPermission !== 5) {
                this.$router.push({
                  path: 'launch-product',
                  query: {
                    to: this.$route.query.to,
                  },
                })
              } else {
                this.$router.push({
                  name: 'const-center-real-success',
                })
              }
            }
          } else {
            // 未认证
            this.$message.error('未完成实名认证')
            await this.requestAccessData()
            this.visible = false
          }
        }
      } catch (err) {
        console.error(
          '❌ ~ file: real-name.vue:283 ~ completeCertification ~ err:',
          err
        )
      }
    },

    skip() {
      this.$router.push({
        path: 'launch-product',
        query: {
          to: this.$route.query.to,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.real-name {
  background-color: #f3f5f8;
  height: calc(100vh - 96px);
  padding-top: 16px;
  box-sizing: border-box;
  > .content {
    width: 1040px;
    margin: 0 auto;
    background-color: #fff;
    padding: 0 80px;
    padding-top: 60px;
    padding-bottom: 100px;
    box-sizing: border-box;
    h6 {
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 16px;
      color: #16181a;
      letter-spacing: 0;
      margin-bottom: 24px;
    }
    p {
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #16181a;
      letter-spacing: 0;
      line-height: 20px;
      margin-bottom: 24px;
      &:last-of-type {
        margin-bottom: 48px;
      }
    }
    .el-form-item {
      margin-bottom: 40px;
      .read-only {
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #16181a;
        letter-spacing: 0;
        height: 14px;
        line-height: 14px;
        padding-left: 8px;
      }
    }
    ::v-deep .el-form-item__label {
      color: #16181aff;
      font-size: 14px;
      font-weight: 400;
      line-height: 0;
      letter-spacing: 0;
      text-align: left;
      margin-bottom: 16px;
    }
    .btn {
      margin-top: 92px;
      text-align: center;
      .el-button {
        width: 216px;
        height: 44px;
        background: #066eb7;
        border-radius: 4px;
        font-family: SourceHanSansCN-Medium;
        font-size: 16px;
        color: #ffffff;
        font-weight: normal;
        line-height: 0;
      }
    }
    .text-btn {
      margin-top: 10px;
      text-align: center;
    }
    .icon-icon-xinxi {
      color: #4f5d78;
      font-size: 14px;
    }
  }
  ::v-deep &-dialog {
    el-dialog__body {
      padding: 32px;
    }
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        top: 30px;
        right: 32px;
        font-size: 20px;
        i {
          font-weight: bold;
        }
      }
    }
    .content {
      text-align: center;
      > h6 {
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #16181a;
      }
      > p {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        height: 14px;
        color: #4f5d78;
        margin-top: 20px;
        margin-bottom: 40px;
      }
      .el-button {
        width: 216px;
        height: 40px;
        background: #066eb7;
        border-radius: 4px;
        margin-bottom: 8px;
      }
      > div {
        text-align: center;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #98a3b7;
        margin-top: 8px;
      }
    }
  }
}
</style>
